<template>
  <div
    class="timer rounded min-w-125px shadow-sm border hover:shadow-2xl transition ease-in-out text-center flex flex-col justify-center bg-white relative overflow-hidden VZ_TABLE_INPUT"
    @click="globalClick"
    v-bind="$attrs"
    :style="style"
  >
    <div class="display mt-3">
      <p class="text-xl cursor-pointer group" @click="retime">
        <span class="text-6xl fs-4">{{ display }}</span
        ><span class="text-xl text-gray-500">.{{ displayms }}</span>
        <!-- <span class="text-xl hidden group-hover:inline"
          ><client-only
            ><Icon icon="clarity:pencil-solid" :inline="true" /></client-only
        ></span> -->
      </p>
    </div>
    <div
      class="d-flex flex-center align-items-center justify-content-between fv-row border-top p-2"
    >
      <button
        class="btn btn-icon btn-success btn-circle btn-sm m-1"
        type="button"
        @click="start"
        v-if="!isStarted"
      >
        <i class="bi bi-play-fill fs-1"></i>
      </button>
      <button
        class="btn btn-icon btn-dark btn-circle btn-sm m-1"
        type="button"
        @click="pause"
        v-else
      >
        <i class="bi bi-pause-fill fs-1"></i>
      </button>
      <button
        class="btn btn-icon btn-danger btn-circle btn-sm m-1"
        type="button"
        @click="stop"
        v-if="!isStopped"
      >
        <i class="bi bi-stop-fill fs-1"></i>
      </button>
      <button
        class="btn btn-icon btn-primary btn-circle btn-sm m-1"
        type="button"
        @click="countup"
        v-if="!countingUp"
      >
        <i class="fas fa-plus fs-3"></i>
      </button>
      <button
        class="btn btn-icon btn-primary btn-circle btn-sm m-1"
        type="button"
        @click="countdown"
        v-else
      >
        <i class="fas fa-minus fs-3"></i>
      </button>
    </div>
  </div>
</template>

<script>
const timeUnitSeconds = [1, 60, 60 * 60, 24 * 60 * 60];
const convertTimeFromString = (string = "") => {
  const timeUnits = string.split(":").reverse();
  let seconds = 0;
  let isNotNaN = false;
  timeUnits.forEach((unit, index) => {
    if (timeUnitSeconds[index] && !isNaN(unit)) {
      seconds += unit * timeUnitSeconds[index];
      isNotNaN = true;
    }
  });
  if (isNotNaN) return seconds;
  else return NaN;
};
export default {
  props: {
    isPreview: {
      type: Boolean,
    },
  },
  data() {
    return {
      display: "00:00:00",
      displayms: "000",
      d: 0,
      h: 0,
      m: 0,
      s: 0,
      defaultSeconds: 0,
      isStarted: false,
      isStopped: true,
      countingUp: true,
      targetTimestamp: 0,
      pausedDifference: 0,
      isBlinking: false,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      interval: () => {},
    };
  },
  computed: {
    style() {
      return !this.isPreview ? "pointer-events: none" : "";
    },
  },
  methods: {
    start() {
      let nowTimestamp = Date.now();
      let targetTime = this.defaultSeconds;
      if (this.pausedDifference) {
        targetTime = this.pausedDifference;
        this.pausedDifference = 0;
      }
      if (this.countingUp) this.targetTimestamp = nowTimestamp - targetTime;
      else this.targetTimestamp = nowTimestamp + targetTime;
      this.interval = setInterval(() => {
        if (!this.countingUp && this.targetTimestamp - Date.now() < 1) {
          this.stop();
          this.updateDisplay(0);
          this.isBlinking = true;
          console.log(this.isBlinking);
        } else this.updateDisplay();
      }, 10);
      this.isStarted = true;
      this.isStopped = false;
      this.isBlinking = false;
      console.log(this.isBlinking);
    },
    pause() {
      let nowTimestamp = Date.now();
      this.pausedDifference = Math.abs(this.targetTimestamp - nowTimestamp);
      clearInterval(this.interval);
      this.updateDisplay();
      this.isStarted = false;
    },
    stop() {
      if (this.isStarted) this.pause();
      this.reset();
      this.updateDisplay();
      this.isStopped = true;
    },
    reset() {
      let nowTimestamp = Date.now();
      if (this.countingUp)
        this.targetTimestamp = nowTimestamp - this.defaultSeconds;
      else this.targetTimestamp = nowTimestamp + this.defaultSeconds;
      this.pausedDifference = 0;
    },
    updateDisplay(targetTime) {
      // Update both display (hh:mm:ss and miliseconds)
      let nowTimestamp = Date.now();
      if (targetTime !== undefined) {
        if (this.countingUp) this.targetTimestamp = nowTimestamp - targetTime;
        else this.targetTimestamp = nowTimestamp + targetTime;
      }
      const s = Math.abs(Date.now() - this.targetTimestamp) / 1000;
      this.ms = Math.floor((s % 1) * 1000);
      this.s = Math.floor(s % 60);
      this.m = Math.floor(s / 60) % 60;
      this.h = Math.floor(s / 3600) % 24;
      this.d = Math.floor(s / 86400);
      let display = this.s.toString().padStart(2, "0");
      display = this.m.toString().padStart(2, "0") + ":" + display;
      display = this.h.toString().padStart(2, "0") + ":" + display;
      if (this.d) display = this.d.toString().padStart(2, "0") + ":" + display;
      this.display = display;
      this.displayms = ("000" + this.ms).slice(-3);
      // console.log(display)
    },
    countup() {
      // Switch to counting up
      this.countingUp = true;
      let nowTimestamp = Date.now();
      let difference = Math.abs(this.targetTimestamp - nowTimestamp);
      this.targetTimestamp = nowTimestamp - difference;
      // this.updateDisplay()
    },
    countdown() {
      // Switch to counting down
      this.countingUp = false;
      let nowTimestamp = Date.now();
      let difference = Math.abs(this.targetTimestamp - nowTimestamp);
      this.targetTimestamp = nowTimestamp + difference;
      // this.updateDisplay()
    },
    async retime() {
      // To change the time
      let { value: input } = await this.$swal.fire({
        title: "Enter the new time",
        input: "text",
        inputValue: this.defaultSeconds / 1000,
        showCancelButton: true,
        inputValidator: (input) => {
          let inputSecs = convertTimeFromString(input);
          console.log(inputSecs);
          if (Number.isNaN(Number(inputSecs))) {
            return "Enter a valid value!";
          } else if (inputSecs < 0) {
            return "Enter a positive number!";
          }
        },
      });
      if (!input) return;
      this.defaultSeconds = convertTimeFromString(input) * 1000;
      this.updateDisplay(this.defaultSeconds);
      if (this.pausedDifference) this.pausedDifference += this.defaultSeconds;
    },
    globalClick() {
      this.isBlinking = false;
    },
  },
};
</script>

<style>
.timer-blinking {
  animation-duration: 1000ms;
  animation-name: blink;
  animation-iteration-count: infinite;
  animation-direction: normal;
}
@keyframes blink {
  from {
    opacity: 1;
  }
  49% {
    opacity: 1;
  }
  51% {
    opacity: 0.25;
  }
  to {
    opacity: 0.25;
  }
}
</style>
